import {
  Component, OnInit, OnDestroy, AfterViewInit,
  ChangeDetectorRef, NgZone, Output, ViewChild
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectBox } from 'cbc-shared-lib';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import {
  Sgkb702aRequest, ResponseCommon, CodeConversionMstDto,
  Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto, Sgkb702aResInclusiontargetDemandctrinfoDto
} from 'sg-api';
import { UsedSgkb702aService } from '../../../sgkb701d/services/used-sgkb702a.service';
import { Sgkb708dCtrinfoComponent } from '../../components/sgkb708d-ctrinfo/sgkb708d-ctrinfo.component';
import { Sgkb708dInclutagsupdemandctrComponent } from '../../components/sgkb708d-inclutagsupdemandctr/sgkb708d-inclutagsupdemandctr.component';
import { Sgkb708dAppliinfoComponent } from '../../components/sgkb708d-appliinfo/sgkb708d-appliinfo.component';
import { Sgkb708dButtonComponent } from '../../components/sgkb708d-button/sgkb708d-button.component';

interface NewSgkb702aResInclusiontargetDemandctrinfoDto extends Sgkb702aResInclusiontargetDemandctrinfoDto {
  /** 契約状態（prdBreakDateの有無、ctrendDate=99991231で表示切替） */
  keiyakuJotai?: string;
  /** エネルギー種別と熱量の区切り文字 */
  pipe?: string;
  /** 熱量の単位表示 */
  unitHeat?: string;
  /** 割引・割増金額の単位表示 */
  unitMny?: string;
  /** 割引・割増率の単位表示 */
  unitRate?: string;
}

@Component({
  selector: 'app-sgkb708d',
  templateUrl: './sgkb708d.component.html',
  styleUrl: './sgkb708d.component.scss'
})
export class Sgkb708dComponent implements OnInit, OnDestroy, AfterViewInit {

  @Output() errorMessageModelArray: Array<SgAriaMessage> = [];
  /** 子コンポーネント */
  @ViewChild(Sgkb708dCtrinfoComponent) sgkb708dCtrinfoComponent!: Sgkb708dCtrinfoComponent;
  @ViewChild(Sgkb708dInclutagsupdemandctrComponent) sgkb708dInclutagsupdemandctrComponent!: Sgkb708dInclutagsupdemandctrComponent;
  @ViewChild(Sgkb708dAppliinfoComponent) sgkb708dAppliinfoComponent!: Sgkb708dAppliinfoComponent;
  @ViewChild(Sgkb708dButtonComponent) sgkb708dButtonComponent!: Sgkb708dButtonComponent;

  /** 包括契約情報格納FormGroup */
  registContractForm: UntypedFormGroup;
  /** 包括契約需供契約一覧格納FormGroup */
  jyukyuListForm: UntypedFormGroup;
  /** 申込状況格納FormGroup */
  appliInfoForm: UntypedFormGroup;
  /** ボタン格納FormGroup */
  buttonForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 包括情報コンポーネントの包括割引・割増方法選択値の格納 */
  eventData: string;
  /** 包括お客さま番号 */
  paraInclusioncontractVisitornumber: string;
  /** 包括契約履歴番号 */
  paraInclusioncontractRrkno: string;
  /** 包括契約年度内通番号 */
  paraInclusioncontractYearnaiSrno: string;
  /** 申請状況コード */
  paraAppJokyo: string;
  /** 遷移元ステータス */
  mode: string;
  /** 画面タイトル */
  dispTitle: string;
  /** 包括契約受付状態情報表示フラグ */
  appliInfoDispFlg: boolean;
  dataSource: MatTableDataSource<NewSgkb702aResInclusiontargetDemandctrinfoDto>;
  /** 各コンポーネント表示フラグ */
  dispFlg: boolean = false

  /** コード一覧 */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** responseCommon(SGKB702A) */
  sgkb702aResponseCommon: ResponseCommon;
  /** 包括契約情報 */
  incCtrSearchresult: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;

  /** 契約担当部署のセレクトボックスデータ */
  keiyakuTantouBushoList: SelectBox[] = [];

  /** 包括契約検索フラグ */
  incCtrFlg: boolean = false

  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private codeConversionMstService: CodeConversionMstService,
    private usedSgkb702aService: UsedSgkb702aService,
  ) {
    this.registContractForm = this.fb.group({});
    this.jyukyuListForm = this.fb.group({});
    this.appliInfoForm = this.fb.group({});
    this.buttonForm = this.fb.group({});
  }

  /**
   * 初期処理
   * @memberof Sgkb708dComponent
   */
  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      // 画面遷移時のパラメータ取得
      // 包括お客さま番号
      this.paraInclusioncontractVisitornumber = params.get('inclusioncontractVisitornumber');
      // 包括契約履歴番号
      this.paraInclusioncontractRrkno = params.get('inclusioncontractRrkno');
      // 包括契約年度内通番号
      this.paraInclusioncontractYearnaiSrno = params.get('inclusioncontractYearnaiSrno');
      // 申請状況コード
      this.paraAppJokyo = params.get('appJokyo');
      // 画面遷移時のパラメータ取得
      // 遷移パラメータ  read：参照、create：登録、midterm_change：期中変更、
      //                renewal：契約更改、cancel：解約、approve：承認、delete：取消
      this.mode = params.get('mode');

      // コード値取得
      this.codeConversionMstService.getCodeConversionMst([
        "S000651",// 割引・割増種類コード
      ])
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(data => {
          this.codeConversionMstMap = data;
          this.dispFlg = true;
          this.configureFormControls();
        });

      if ("create" != this.mode) {
        // 包括契約検索リクエスト 
        const sgkb702aRequest: Sgkb702aRequest = {
          // 画面間パラメータをリクエストに設定
          inclusioncontractSearchInfo: {
            // 包括お客さま番号
            inclusioncontractVisitornumber: this.paraInclusioncontractVisitornumber,
            // 包括契約履歴番号
            inclusioncontractRrkno: this.paraInclusioncontractRrkno,
            // 包括契約年度内通番号
            inclusioncontractYearnaiSrno: this.paraInclusioncontractYearnaiSrno,
            // 申請状況コード
            appJokyo: this.paraAppJokyo
          }
        };

        // 包括契約検索レスポンスを取得
        this.usedSgkb702aService.searchContractor(sgkb702aRequest)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(response => {
            this.sgkb702aResponseCommon = response.responseCommon;
            this.incCtrSearchresult = response.inclusioncontractInclutagsupdemandctrSearchresult;
            //包括契約検索を行ったためtrueに
            this.incCtrFlg = true;
          });
      } else {
        //包括契約検索を行わないためtrueに
        this.incCtrFlg = true;
      }

      // 再表示時には子コンポーネントの初期処理は実行されないため
      // 親コンポーネントから子コンポーネントの初期処理を呼び出す。
      // また初回表示時は子コンポーネントが存在しないため以下の処理は実行されない
      if (this.sgkb708dCtrinfoComponent) {
        this.sgkb708dCtrinfoComponent.mode = this.mode;
        this.sgkb708dCtrinfoComponent.ngOnInit();
        this.registContractForm.reset();
        this.registContractForm.updateValueAndValidity();
      }
      if (this.sgkb708dInclutagsupdemandctrComponent) {
        this.sgkb708dInclutagsupdemandctrComponent.mode = this.mode;
        this.sgkb708dInclutagsupdemandctrComponent.ngOnInit();
        this.jyukyuListForm.reset();
        this.jyukyuListForm.updateValueAndValidity();
      }
      if (this.sgkb708dAppliinfoComponent) {
        this.sgkb708dAppliinfoComponent.mode = this.mode;
        this.sgkb708dAppliinfoComponent.ngOnInit();
        this.appliInfoForm.reset();
        this.appliInfoForm.updateValueAndValidity();
      }
      if (this.sgkb708dButtonComponent) {
        this.sgkb708dButtonComponent.mode = this.mode;
        this.sgkb708dButtonComponent.ngOnInit();
        this.buttonForm.reset();
        this.buttonForm.updateValueAndValidity();
      }
    });
  }

  /**
   * フォーム制御処理
   * @memberof Sgkb708dAppliinfoComponent
   */
  configureFormControls(): void {
    // 画面タイトル
    // 遷移パラメータが 参照 の場合
    if (this.mode === 'read') {
      this.dispTitle = '包括契約照会';
      // 包括契約受付状態情報コンポーネント（表示）
      this.appliInfoDispFlg = true;
    }
    // 遷移パラメータが 登録 の場合
    else if (this.mode === 'create') {
      this.dispTitle = '包括契約登録';
      // 包括契約受付状態情報コンポーネント（非表示）
      this.appliInfoDispFlg = false;
    }
    // 遷移パラメータが 期中変更 の場合
    else if (this.mode === 'midterm_change') {
      this.dispTitle = '包括契約変更';
      // 包括契約受付状態情報コンポーネント（非表示）
      this.appliInfoDispFlg = false;
    }
    // 遷移パラメータが 契約更改 の場合
    else if (this.mode === 'renewal') {
      this.dispTitle = '包括契約更改';
      // 包括契約受付状態情報コンポーネント（非表示）
      this.appliInfoDispFlg = false;
    }
    // 遷移パラメータが 解約 の場合
    else if (this.mode === 'cancel') {
      this.dispTitle = '包括契約解約';
      // 包括契約受付状態情報コンポーネント（非表示）
      this.appliInfoDispFlg = false;
    }
    // 遷移パラメータが 承認 の場合
    else if (this.mode === 'approve') {
      this.dispTitle = '包括契約承認';
      // 包括契約受付状態情報コンポーネント（非表示）
      this.appliInfoDispFlg = false;
    }
    // 遷移パラメータが 取消 の場合
    else if (this.mode === 'delete') {
      this.dispTitle = '包括契約取消';
      // 包括契約受付状態情報コンポーネント（非表示）
      this.appliInfoDispFlg = false;
    }
  }

  /**
   * コンポーネントのビュー初期化直後の処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngAfterViewInit(): void {
    // 非同期処理の変更点を制御（ExpressionChangedAfterItHasBeenCheckedErrorの回避）
    this.ngZone.run(() => {
      // 自コンポーネント内のフォーム状態を最新化
      this.registContractForm.updateValueAndValidity();
      this.jyukyuListForm.updateValueAndValidity();
      this.appliInfoForm.updateValueAndValidity();
      this.buttonForm.updateValueAndValidity();
      // 変更検出を行い、ビューとデータの整合性を確保
      this.cdr.detectChanges();
    });
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb708dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    // 包括契約情報格納FormGroup
    this.registContractForm.clearValidators();
    this.registContractForm.updateValueAndValidity();
    this.registContractForm.removeControl('registContractForm');
    // 包括契約需供契約一覧格納FormGroup
    this.jyukyuListForm.clearValidators();
    this.jyukyuListForm.updateValueAndValidity();
    this.jyukyuListForm.removeControl('jyukyuListForm');
    // 申込状況格納FormGroup
    this.appliInfoForm.clearValidators();
    this.appliInfoForm.updateValueAndValidity();
    this.appliInfoForm.removeControl('appliInfoForm');
    // ボタン格納FormGroup
    this.buttonForm.clearValidators();
    this.buttonForm.updateValueAndValidity();
    this.buttonForm.removeControl('buttonForm');
  }

  /**
   * 包括情報コンポーネントからの受領値設定
   * @memberof Sgkb708dComponent
   */
  setValue(eventData: string): void {
    this.eventData = eventData;
  }

  /**
   * 包括契約需給契約一覧コンポーネントからの受領値設定
   * @memberof Sgkb708dComponent
   */
  onDataSourceChanged(ds: MatTableDataSource<NewSgkb702aResInclusiontargetDemandctrinfoDto>) {
    this.dataSource = ds;
  }

  /**
   * エラーメッセージ表示設定（包括契約需給契約一覧コンポーネントから受領）
   * @memberof Sgkb708dComponent
   */
  pushSgAriaMessage(message: string): void {
    let errorMessageModelForEditArray: Array<SgAriaMessage> = [...this.errorMessageModelArray];
    errorMessageModelForEditArray.push({
      message: message
      , messageClass: "mat-card-background-error"
      , icon: "cancel"
      , iconClass: "mat-icon-color-error"
    });
    this.errorMessageModelArray = errorMessageModelForEditArray;
  }

  /**
   * メッセージ領域のクリア
   * @memberof Sgkb708dComponent
   */
  clearMessage(): void {
    this.errorMessageModelArray = [];
  }
}
